import Joi from 'joi';

import { createTagsSchema } from '../../../tags/validators/schemas/create-tags.schema';

/**
 * Schema for new report job record validation.
 */
export const createReportJobSchema = () =>
	Joi.object({
		// User id
		userId: Joi.number().allow(null).optional(),

		// Tags
		tags: createTagsSchema().messages({
			'array.base': 'validations|report-job-tags|invalid-value',
		}),
	})
		// Ignore extra fields
		.unknown();
